const playlist_songs = [

	{
		title: "Blossom",
		active : true,
		url: "00_placeholder_ch3.mp4",
		release : 3,
		release_end : "rd"
	},
	{
		title: "Ego",
		active : false,
		url: "01_placeholder_ch3.mp4",
		release : 4,
		release_end : "th"

	},
	{
		title: "Firebird",
		active : false,
		url: "02_placeholder_ch3.mp4",
		release : 5,
		release_end : "th"
	},
	{
		title: "Doing Good",
		active : false,
		url: "03_placeholder_ch3.mp4",
		release : 6,
		release_end : "th"
	},
	{
		title: "Clouds",
		active : false,
		url: "04_placeholder_ch3.mp4",
		release : 7,
		release_end : "th"
	},
	{
		title: "Cold Blue Rain",
		active : false,
		url: "05_placeholder_ch3.mp4",
		release : 8,
		release_end : "th"
	},
	{
		title: "Stay",
		active : false,
		url: "06_placeholder_ch3.mp4",
		release : 9,
		release_end : "th"
	},
	{
		title: "Bad Things",
		feat : "feat. Izzy Bizu",
		active : false,
		url: "07_placeholder_ch3.mp4",
		release : 10,
		release_end : "th"
	},
	{
		title: "Cocoon",
		active : false,
		url: "08_placeholder_ch3.mp4",
		release : 11,
		release_end : "th"
	},
	{
		title: "Losing You",
		active : false,
		url: "09_placeholder_ch3.mp4",
		release : 12,
		release_end : "th"
	},
	{
		title: "Peripeteia",
		active : false,
		url: "10_placeholder_ch3.mp4",
		release : 13,
		release_end : "th"
	},
	{
		title: "Alive",
		active : false,
		url: "11_placeholder_ch3.mp4",
		release : 14,
		release_end : "th"
	},
	{
		title: "Piano Song",
		active : false,
		url: "12_placeholder_ch3.mp4",
		release : 15,
		release_end : "th"
	},
	{
		title: "Heartless",
		active : false,
		url: "13_placeholder_ch3.mp4",
		release : 16,
		release_end : "th"
	},

]

export default playlist_songs;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/songs.js